export const grey = '#87898b';
export const purple = '#9900a5';
export const green = '#16b7b3';
